export default __webpack_public_path__ + "static/media/Menu.1ff30e20.svg";